import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';
import React, { useState } from 'react';

import { Header } from './components/Header';
import { PartnerAdvisorsWarning } from './components/PartnerAdvisorsWarning';
import { TabSelector } from './components/TabSelector';
import {
  TransactionFlowAvailableTabs,
  transactionFlowInitialTab,
  transactionFlowTabs,
} from './constants';

export const TransactionFlow = () => {
  const [selectedTab, setSelectedTab] =
    useState<TransactionFlowAvailableTabs>(transactionFlowInitialTab);
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  const ContentComponent = transactionFlowTabs[selectedTab].component;

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View minW="container">
        <VStack
          py={Spacing['inset.lg']}
          space={Spacing['inline.xxs']}
          px={{ base: Spacing['stack.xxxs'], sm: Spacing['inline.xxs'], lg: 0 }}>
          <Header title="Fluxo de Movimentações" />
          <TabSelector
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            isMobile={isMobile}
          />
          <PartnerAdvisorsWarning />
          <ContentComponent />
        </VStack>
      </View>
    </ScrollView>
  );
};
